import { getApiBaseUrl } from "../config/runtimeConfig";

const apiBaseUrl = getApiBaseUrl();

export class ApiError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

/** O quadro "Resumo" anual: faturado, despesa s/IVA, resultado, imposto e incidência. */
export interface FinancialSummary {
  year: number;
  companyId?: number | null;
  invoicedNet: number;
  expenseNet: number;
  result: number;
  /** Taxa aplicada ao resultado (0.225 = 22,5%). */
  taxRate: number;
  tax: number;
  /** Resultado ÷ faturado, como rácio (0.086 = 8,6%). */
  incidence: number;
  undatedRevenueCount: number;
  undatedExpenseCount: number;
}

async function request<T>(path: string): Promise<T> {
  const response = await fetch(`${apiBaseUrl}${path}`, { credentials: "include" });

  if (!response.ok) {
    const text = await response.text();
    throw new ApiError(response.status, text || response.statusText);
  }

  return (await response.json()) as T;
}

export function getFinancialSummary(
  year: number,
  companyId?: number | null,
): Promise<FinancialSummary> {
  const params = new URLSearchParams({ year: String(year) });
  if (companyId != null) params.set("companyId", String(companyId));
  return request<FinancialSummary>(`/api/financial-summary?${params.toString()}`);
}
